import {useMemo} from 'react';
import querystring from 'querystring'

const getObj = (location) => {
    const search = location.search;
    return querystring.parse(search.substr(1));
}
export default (location = window.location) => {
    // eslint-disable-next-line
    const params = useMemo(() => getObj(location), [location.search])
    return params;
}